import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home/Home'; 
import Scan from './pages/Scan/Scan'; 



function App() {
  return (
    <Router>     
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
      <Routes>
        <Route path="/scan" element={<Scan />} />
      </Routes>
    </Router>
  );
}

export default App;
